import affixDirective from './directiveDef';

export default angular.module('relayComps.affixDiv', [])
  .directive('affixDiv', affixDirective)
  .name;
